import React from 'react'
import { Row, Col, Card, Space, Table, Button, Typography } from 'antd'
import { UserOutlined, CalendarOutlined, ClockCircleOutlined } from '@ant-design/icons'
import { formatDateTime, getStatusBadge, getUrgencyTag, getPriorityTag } from '../../utils/formatters'

const { Text } = Typography

const PatientsTab = ({ recentAdmissions, upcomingSurgeries, tasksDueToday }) => {
  return (
    <Row gutter={[16, 16]}>
      {/* Recent Admissions */}
      <Col xs={24} lg={12}>
        <Card
          title={
            <Space>
              <UserOutlined />
              <span>Recent Admissions</span>
            </Space>
          }
          extra={<Button type='link'>View All</Button>}
          style={{ marginBottom: '16px', height: '100%' }}
        >
          <Table
            dataSource={recentAdmissions}
            rowKey='admissionId'
            pagination={false}
            columns={[
              {
                title: 'Patient',
                dataIndex: 'patientName',
                render: (text, record) => (
                  <Space direction='vertical' size={0}>
                    <Text>{text}</Text>
                    <Text type='secondary' style={{ fontSize: '12px' }}>
                      {record.patientId}
                    </Text>
                  </Space>
                )
              },
              {
                title: 'Date',
                dataIndex: 'admissionDate',
                render: (date) => formatDateTime(date)
              },
              {
                title: 'Department',
                dataIndex: 'department'
              },
              {
                title: 'Status',
                dataIndex: 'status',
                render: (status) => getStatusBadge(status)
              }
            ]}
          />
        </Card>
      </Col>

      {/* Upcoming Surgeries */}
      <Col xs={24} lg={12}>
        <Card
          title={
            <Space>
              <CalendarOutlined />
              <span>Upcoming Surgeries</span>
            </Space>
          }
          extra={<Button type='link'>View All</Button>}
          style={{ marginBottom: '16px', height: '100%' }}
        >
          <Table
            dataSource={upcomingSurgeries}
            rowKey='surgeryId'
            pagination={false}
            columns={[
              {
                title: 'Patient',
                dataIndex: 'patientName',
                render: (text, record) => (
                  <Space direction='vertical' size={0}>
                    <Text>{text}</Text>
                    <Text type='secondary' style={{ fontSize: '12px' }}>
                      {record.patientId}
                    </Text>
                  </Space>
                )
              },
              {
                title: 'Surgery',
                dataIndex: 'surgeryType'
              },
              {
                title: 'Scheduled',
                dataIndex: 'scheduledDateTime',
                render: (date) => formatDateTime(date)
              },
              {
                title: 'Urgency',
                dataIndex: 'urgency',
                render: (urgency) => getUrgencyTag(urgency)
              }
            ]}
          />
        </Card>
      </Col>

      {/* Tasks Due Today */}
      <Col xs={24}>
        <Card
          title={
            <Space>
              <ClockCircleOutlined />
              <span>Tasks Due Today</span>
            </Space>
          }
          extra={<Button type='link'>View All</Button>}
        >
          <Table
            dataSource={tasksDueToday}
            rowKey='taskId'
            pagination={{ pageSize: 5 }}
            columns={[
              {
                title: 'Task',
                dataIndex: 'taskDescription'
              },
              {
                title: 'Patient',
                dataIndex: 'patientName',
                render: (text, record) => (
                  <Space direction='vertical' size={0}>
                    <Text>{text}</Text>
                    <Text type='secondary' style={{ fontSize: '12px' }}>
                      {record.patientId}
                    </Text>
                  </Space>
                )
              },
              {
                title: 'Assigned To',
                dataIndex: 'assignedToStaffName'
              },
              {
                title: 'Due',
                dataIndex: 'dueDate',
                render: (date) => formatDateTime(date)
              },
              {
                title: 'Priority',
                dataIndex: 'priority',
                render: (priority) => getPriorityTag(priority)
              },
              {
                title: 'Status',
                dataIndex: 'taskStatus',
                render: (status) => getStatusBadge(status)
              }
            ]}
          />
        </Card>
      </Col>
    </Row>
  )
}

export default PatientsTab
